(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import { Icon } from "../icons";
var StyledListItem = styled('li').withConfig({
  displayName: "ListItem__StyledListItem",
  componentId: "sc-1cms8t0-0"
})(["list-style:none;margin-left:0;padding-left:0;"]);
var ListItem = styled(function (props) {
  var children = props.children,
      icon = props.icon,
      rest = _objectWithoutProperties(props, ["children", "icon"]);

  return React.createElement("li", rest, children);
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-1cms8t0-1"
})(["list-style:none;margin-left:0;padding-left:0;"]);
var _default = ListItem;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledListItem, "StyledListItem", "/home/vsts/work/1/s/src/components/lists/ListItem.js");
  reactHotLoader.register(ListItem, "ListItem", "/home/vsts/work/1/s/src/components/lists/ListItem.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/lists/ListItem.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();